module.exports = __webpack_public_path__ + "static/media/treasure.1c4b13d9.svg";